import React from 'react'

function DbMenuIcon(props) {
  return (
    <svg className={props.className} width="30" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 3H3V5H21V3Z" fill={props.fill}/>
<path d="M21 19H3V21H21V19Z" fill={props.fill}/>
<path d="M21 11H3V13H21V11Z" fill={props.fill}/>
</svg>

  )
}

export default DbMenuIcon